export default "__VITE_ASSET__DPWQ5DLh__"